import { render, staticRenderFns } from "./ExchangeInfo.vue?vue&type=template&id=6f0dd80c&scoped=true"
import script from "./ExchangeInfo.vue?vue&type=script&lang=js"
export * from "./ExchangeInfo.vue?vue&type=script&lang=js"
import style0 from "./ExchangeInfo.vue?vue&type=style&index=0&id=6f0dd80c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0dd80c",
  null
  
)

export default component.exports